import { Navigate, Outlet } from 'react-router';

import { useAuth } from '../modules/auth/hooks/use-auth';
import { canReadCompanies } from '../modules/auth/utils/company-permissions';

export const CompanyAccessGuard = () => {
  const { permissions } = useAuth();

  return canReadCompanies(permissions) ? <Outlet /> : <Navigate to="/" replace />;
};
